import { Route } from "react-router-dom";
import ClientServices from "../components/index";

const ClientServicesRoutes = () => (
  <>
    <Route path="/client-services/:serviceTypeId?" element={<ClientServices />} />
  </>
);


export default ClientServicesRoutes;